import React, { FC, useContext } from 'react'
import { SplitContext } from '../../utils/SplitContext'
import { StyledAccountSettings, Profile, SocialProfiles } from '..'

const AccountSettings: FC = () => {
  const {
    isReady,
    isEnabled,
    treatments: { socialProfiles }
  } = useContext(SplitContext)
  const socialProfilesEnabled = isReady && isEnabled(socialProfiles)

  return (
    <StyledAccountSettings>
      <div className="account-settings-header-container">
        <div className="account-settings-header">
          <h1>Account Settings</h1>
          <h2>Manage your account & social profiles</h2>
        </div>
      </div>
      <div className="account-settings-content">
        <div className="account-settings-group">
          <Profile />
        </div>
        {socialProfilesEnabled && (
          <div className="account-settings-group">
            <SocialProfiles />
          </div>
        )}
      </div>
    </StyledAccountSettings>
  )
}

export default AccountSettings
